import Droppable from './Droppable';

export default Droppable;
